import Navbar from './components/Navbar/Navbar'
import './App.css'
import Intro from './components/Intro/Intro'
import Services from './components/Services/Services'
import Works from './components/Works/Works'
import Portfolio from './components/Portfolio/Portfolio'
import Experience from './components/Experience/Experience'
import Testimonial from './components/Testimonials/Testimonial'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'
import { themeContext } from './Context'
import { useContext } from 'react'

function App() {
  const theme = useContext(themeContext)
  return (
    <div className={`App${theme.state.darkMode ? ' dark-mode' : ''}`}>
      <Navbar />
      <main>
        <Intro />
        <Services />
        <Works />
        <Experience />
        <Portfolio />
        <Testimonial />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
export default App
